class EventsFilter {

  constructor(){
    this.triggers = document.querySelectorAll(`[data-trigger="events-filter"]`);
    this.target  = document.querySelector(`[data-target="events-filter"]`);
		this._init();
	}

 _init(){
    
	  document.addEventListener('DOMContentLoaded', (event) => {
	  	if(this.triggers && this.triggers.length > 0) {
        for (var i = 0; i < this.triggers.length; i++) {
          this.triggers[i].addEventListener('change', 
			    	this._setFilter.bind(this),
			    	false
			    );
        }
      }
	  });
	}

	/**
	 * A chaque modification de la date,
	 * on mets à jour la liste des événements
	 */
	_setFilter(){
		console.log('events-filter::_setFilter');
		this.target.submit();
	}
}

export let eventsFilter = new EventsFilter();
